export function createRandomValue() {
    return String(crypto.getRandomValues(new Uint32Array(1))[0]);
}
//# sourceMappingURL=create-random-value.js.map